import {Button, Dialog, setNotification} from '@startlibs/components'
import {ToggleCheckbox} from '@startlibs/form'
import { css } from 'styled-components';
import {getFetcher} from '@startlibs/utils'
import {useToggle} from '@startlibs/core'
import React from 'react'

import {CopyButton, CopyLinkComponent} from 'sharecomponents/src/pages/ShareDialog'

import {FetchErrorDialog} from '../pages/errors/FetchErrorDialog'

export const ORIGIN = window.location.origin

export const ShareUploadLinkDialog = ({closeDialog}) => {
  const linkLoading = useToggle(true)
  const linkUrl = useToggle('')
  const expirable = useToggle()
  const error = useToggle()

  const loadInstantLink = () => {
    linkLoading.open()
    getFetcher("/dicomuploaderjwt.php?mode="+(expirable.get() ? "timed" : "public"))
      .then((jwt) => linkUrl.openWith(ORIGIN + "/dicomuploader.php?auth="+jwt.trim()))
      .catch((e) => error.open())
      .finally(() => linkLoading.close())
  }
  React.useEffect(() => {
    loadInstantLink()
  },[expirable.isOpen])

  if (error.isOpen) {
     return <FetchErrorDialog
       closeDialog={closeDialog}
       message="An error has occurred while trying to load the link. Please refresh the page and try again."
     />
  }
  return <Dialog
    className="JS-copy-focus-container"
    title="Uploader link"
    closeDialog={closeDialog}
    footer={<>
      <Button onClick={closeDialog}>Cancel</Button>
      <CopyButton
        highlight text={linkUrl.isOpen} url={linkUrl.isOpen} onCopy={(supported) => {
          if (supported) {
            setNotification("Link copied to the clipboard");
          }
        closeDialog()
      }} isLoading={linkLoading.isOpen}
      >Copy link & close</CopyButton>
    </>}
  >
    <CopyLinkComponent
      url={linkUrl.isOpen} label="Share the link below for the upload of DICOM studies"
      key={linkUrl.isOpen}
      loadingShareableLink={linkLoading.isOpen}
    />
    <ToggleCheckbox
      label={<b>Expire link after 48 hours</b>}
      raw
      value={expirable.isOpen}
      setValue={expirable.toggle}
      css="margin-top:1rem;"
    />
  </Dialog>
}